export const getClaimType = (claimType) => {
  switch (claimType?.toLowerCase()) {
    case "dth":
      return "Death Claim";
    case "dis":
      return "Disability Claim";
    default:
      return "";
  }
};
